import { Outlet, Navigate } from "react-router-dom";

const AccountingRoutes = (props) => {
   return props.accountant ? <Outlet /> : <Navigate to="/login" />;
};

export default AccountingRoutes;
